import Vue from 'vue';
import App from './App.vue';
// import Eruda from 'eruda';
import './assets/styles/reset.styl';
import './assets/styles/show.css';
import "babel-polyfill";
import "core-js/stable";
import "regenerator-runtime/runtime";
import {store} from './store';
import Pandora from './plugins/pandora';
import router from './router';
import {Toast, Loading, Skeleton } from 'vant';

Vue.use(Loading);
Vue.use(Toast);
Vue.use(Skeleton)

// 引入埋点
import choosecomponent from '@/components/activeModal/common.js';
// import config from '../config';

Vue.prototype.$toast = Toast;

Vue.use(Pandora);
Vue.prototype.$choosecomponent = choosecomponent;
Vue.config.productionTip = false;

// // 非线上环境下开启页面调试
// if (config.NODE_ENV !== 'production' && config.NODE_ENV !== 'pre') {
//   Eruda.init();
// }

const vm = new Vue({
  render: (h) => h(App),
  store,
  router,
}).$mount('#app');

export default vm;
